// extracted by mini-css-extract-plugin
module.exports = {"leftWrapper":"PaymentScreen_leftWrapper__1FQeK"};